<template>
    <div class="preview-template">
        <div class="top-header preview-header d-flex justify-content-between">
            <div class="top-left">
                <a class="animated-arrow backwards" @click.prevent="back()">
                    <span class="the-arrow -left">
                        <span class="shaft"></span>
                        </span>
                        <span class="main">
                            <span class="text button-text text-primary">{{ $t('common.back') }}</span>
                        <span class="the-arrow -right">
                        <span class="shaft"></span>
                        </span>
                    </span>
                </a>
            </div>
            <div class="top-center">
                <a class="button button-m button-outline" :class="{ t_active: 'desktop' == active }" @click.prevent="setActive('desktop')">{{ $t('common.desktop') }}</a>
                <a class=" button button-m button-outline preview-template__middle-button" :class="{ t_active: 'tablet' == active }" @click.prevent="setActive('tablet')">{{ $t('common.tablet') }}</a>
                <a class=" button button-m button-outline" :class="{ t_active: 'mobile' == active }" @click.prevent="setActive('mobile')">{{ $t('common.mobile') }}</a>
            </div>
            <div class="top-right d-flex">
                <a @click.stop="selectTemplate()" class="button button-m button-black">{{ $t('common.select_template') }}</a>
            </div>
        </div>

        <div class="preview-template__container">
            <iframe :src="getTemplateUrl" v-on:load="iframeLoaded" :class="responsiveClass"></iframe>
        </div>
        <register-popup v-if="form" @closed="form=false" :template_id="template"></register-popup>
    </div>
</template>

<script>
    export default {
        props: {
            template: Number,
            back_route: {
                type: String,
                default: ''
            },
        },
        mounted() {
          console.log('ok');
        },
        data() {
          return {
            active: 'desktop',
            form: false,
          }
        },
        methods: {
            setActive(device) {
                this.active = device;
            },
            iframeLoaded(event) {
                // let iframe = event.target;
                // let height = iframe.contentWindow.document.body.scrollHeight + 'px';
                // iframe.height = height;
            },
            back() {
                if (this.back_route != '') {
                    this.$router.push({
                        name: this.back_route
                    })
                } else {
                    javascript:history.go(-1);
                }
            },
            selectTemplate() {
                this.form = true;
            },
        },
        computed: {
            responsiveClass() {
                return `t_${this.active}`;
            },
            getTemplateUrl() {
              return `/template/${this.template}`;
            } 
        }
    }
</script>